import React, { Component } from 'react';
import {
  List, Toast, Radio, Icon,
} from 'antd-mobile';
import PropTypes from 'prop-types';
import styles from './index.module.less';
import { getSaleCarsList } from '../../service/car-service';
import AddModal from './component/index';

const { RadioItem } = Radio;

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    go: PropTypes.func,
  }).isRequired,
};

const defaultProps = {
};
/**
 * 车型
 */
class Model extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      seriesAndCars: {},
      brandAndSeries: {},
      value: '',
      isShow: false,
      name: '',
    };
  }

  componentDidMount() {
    this.loadDate();
  }

  handleChangeHistory = () => {
    const { history } = this.props;
    history.go(-1);
  }

  loadDate = () => {
    getSaleCarsList().then((res) => {
      this.setState({
        list: res.data.brands,
        seriesAndCars: res.data.seriesAndCars,
        brandAndSeries: res.data.brandAndSeries,
      });
    }).catch((error) => {
      Toast.show(error.message || '获取失败');
    });
  }

  handleChangeRadio = (item) => {
    this.setState({
      value: item.value,
      name: item.label,
      seriesName: item.seriesName,
      isShow: true,
    });
  }

  renderRadioItem = (id) => {
    const { brandAndSeries, value } = this.state;
    const dataList = brandAndSeries[id].map((item) => (
      {
        label: item.brandName,
        value: item.seriesId,
        seriesName: item.seriesName,
      }));
    return dataList.map((item) => (
      <RadioItem
        checked={value === item.value}
        onChange={() => this.handleChangeRadio(item)}
        key={item.value}
      >
        {`${item.label}-${item.seriesName}`}
      </RadioItem>
    ));
  }

  handleChangeOnClose = () => {
    this.setState({
      isShow: false,
    });
  }

  render() {
    const {
      list, seriesAndCars, isShow, value, name, seriesName,
    } = this.state;
    const { history } = this.props;
    return (
      <div className={styles.box}>
        <div className={styles.header}>
          <Icon size="md" type="left" onClick={this.handleChangeHistory} />
          <p> 意向车型 </p>
        </div>
        {
          list.map((item) => (
            <div key={item.brandId} className={styles.boxTwo}>
              <div className={styles.brand}>
                <p>{item.brandName}</p>
              </div>
              <div>
                <List>
                  {this.renderRadioItem(item.brandId)}
                </List>
              </div>
            </div>
          ))
        }
        {
          isShow && (
            <AddModal
              name={name}
              id={value}
              seriesName={seriesName}
              seriesAndCars={seriesAndCars}
              handleChangeOnClose={this.handleChangeOnClose}
              history={history}
            />
          )
        }
      </div>
    );
  }
}

Model.propTypes = propTypes;
Model.defaultProps = defaultProps;
export default Model;
